/* eslint no-console: 0*/
import FocusTrap from 'focus-trap-react';
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'hist... Remove this comment to see the full error message
import { createBrowserHistory } from 'history';
import isEmpty from 'lodash/isEmpty';
import React, { type RefObject } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import { setFocusWithinList } from '../../../../../src/lib/DOMUtils';
import AnotherPlayIcon from '../../../../../static/icons/ic_play_circle_24.svg';
import Playlist24Icon from '../../../../../static/icons/ic_playlist_24.svg';
import Search24Icon from '../../../../../static/icons/ic_search.svg';
import AnotherLogoPremiumWhiteIcon from '../../../../../static/icons/logo_premium_white.svg';
import * as Actions from '../../actions';
import GlobalSearchInput from '../../components/GlobalSearchInput/GlobalSearchInput';
import * as Constants from '../../constants';
import * as D from '../../deps';
import * as Utils from '../../utils';

import EmptySearch from './EmptySearch';
import SearchResultsList from './SearchResultsList';

import './Search.scss';

interface ISearchProps {
  activeUrl: string;
  bottomViewportPadding?: number;
  branding?: string;
  clickedSearchBoxComponent: $TSFixMeFunction;
  closeModal: $TSFixMeFunction;
  closeSearch: $TSFixMeFunction;
  disableBodyScrolling: $TSFixMeFunction;
  enableBodyScrolling: $TSFixMeFunction;
  filterChanged: $TSFixMeFunction;
  filterTypes: [];
  focusPlaceholder?: $TSFixMe;
  hasFetchedData?: boolean;
  hasFocus?: boolean;
  hasResults: boolean;
  hasSearched?: boolean;
  initialFocus?: boolean;
  isAnonymous: boolean;
  isCenterPageSearch: boolean;
  isListenerPremium: boolean;
  isNavLogoDark: boolean;
  isOnboardingPage: boolean;
  isRightRailActive: boolean;
  isScrolled: boolean;
  isSearchActive: boolean;
  isSearchOpen: boolean;
  listenerImgUrl?: string;
  navTheme: string;
  nowPlayingPath?: string;
  onFocusChange: $TSFixMeFunction;
  openDropdown: $TSFixMeFunction;
  openSearch: $TSFixMeFunction;
  pathname: string;
  placeholder?: $TSFixMe;
  resetResults: $TSFixMeFunction;
  router: $TSFixMe;
  searchItemSelect: $TSFixMeFunction;
  searchResults?: $TSFixMe;
  searchResultsRendered: $TSFixMeFunction;
  searchResultsScroll: $TSFixMeFunction;
  searchTerm: string;
  searchType?: string;
  searchUIStateUpdate: $TSFixMeFunction;
  shouldDropSearchToNextLine: boolean;
  showColdStart: boolean;
  stationId?: string;
  theme?: string;
}

// named export for unconnected component (for tests)
export class Search extends React.PureComponent<ISearchProps> {
  constructor(props: ISearchProps) {
    super(props);

    this.searchListRef = React.createRef<HTMLDivElement>();
    this.headerRef = React.createRef<HTMLDivElement>();

    this.beforeSearch = props.pathname;
    if (D.isInSearchPath(this.beforeSearch)) {
      this.beforeSearch = props.nowPlayingPath;
    }

    this.state = {
      containerHeight: 100,
    };
  }
  state: $TSFixMe;

  componentDidMount(): $TSFixMe {
    this.addListeners();
    this.updateAppScrolling();
    this.history = createBrowserHistory();
    this.history.listen((location: $TSFixMe) => {
      if (!D.isInSearchPath(location.pathname)) {
        this.props.closeSearch(this.props.searchType);
      } else {
        this.updateUrlState(this.props.activeUrl);
      }
    });
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'prevProps' implicitly has an 'any' type... Remove this comment to see the full error message
  componentDidUpdate(prevProps, prevState): $TSFixMeFunction {
    if (
      !this.props.isOnboardingPage &&
      this.props.isCenterPageSearch &&
      prevProps.isSearchOpen !== this.props.isSearchOpen
    ) {
      if (this.props.isSearchOpen) {
        this.removeListeners();
      } else {
        this.addListeners();
      }
    }
    if (this.state.containerHeight !== prevState.containerHeight) {
      this.recalculateListHeight();
    }
    if (prevProps.hasFetchedData !== this.props.hasFetchedData) {
      this.recalculateListHeight();
    }
    if (prevProps.hasFocus !== this.props.hasFocus) {
      this.props.onFocusChange(this.props.hasFocus);
    }
    if (prevProps.isSearchOpen !== this.props.isSearchOpen) {
      this.updateAppScrolling();
    }
    // The last condition here is to make sure we don't update this.beforeSearch when landing on search after
    // clicking the browser back button, otherwise it'll be set to the same search path
    if (
      !prevProps.isSearchOpen &&
      this.props.isSearchOpen &&
      !this.props.pathname.startsWith(D.Utils.Route.SEARCH_BASE_PATH)
    ) {
      this.beforeSearch = this.props.pathname;
    }
  }

  componentWillUnmount(): $TSFixMe {
    this.removeListeners();
    this.props.enableBodyScrolling();
  }
  history: $TSFixMe;
  beforeSearch: $TSFixMe;

  searchListRef: RefObject<HTMLDivElement>;
  headerRef: RefObject<HTMLDivElement>;

  hasSearchTerm: $TSFixMeFunction = () => {
    return !isEmpty(this.props.searchTerm) && Utils.isValidSearchTerm(this.props.searchTerm);
  };

  recalculateListHeight: $TSFixMeFunction = () => {
    if (this.props.isSearchOpen && (this.props.hasFetchedData || this.props.hasResults)) {
      const top =
        this.searchListRef.current?.querySelector('.SearchResultsList')?.getBoundingClientRect()
          .top ?? 0;

      this.setState({
        containerHeight: window.innerHeight - top - D.GlobalStyleConstants.TUNER_BAR_HEIGHT,
      });
    } else {
      this.setState({
        containerHeight: 100,
      });
    }
  };

  addListeners: $TSFixMeFunction = () => {
    D.addDocumentEventListener('keydown', this.onKeyDown);
    D.addWindowEventListener('resize', this.recalculateListHeight);
  };

  removeListeners: $TSFixMeFunction = () => {
    D.removeDocumentEventListener('keydown', this.onKeyDown);
    D.removeWindowEventListener('resize', this.recalculateListHeight);
  };

  updateRouteAfterUserInput: $TSFixMeFunction = (term = '', filter) => {
    // We need to double-encode the search term before we add it to history, because
    // the older version of `history` used by the older version of `react-router` we
    // use decodes the path before updating the url in the browser, for reasons:
    // https://github.com/ReactTraining/history/issues/505
    const uriEncodedTerm = encodeURIComponent(encodeURIComponent(term));
    if (filter && !isEmpty(term)) {
      const searchPath = D.getSearchT3Path() + uriEncodedTerm + filter;
      if (this.props.isSearchOpen && filter === this.props.activeUrl) {
        this.history.replace(searchPath);
      } else {
        this.history.push(searchPath);
      }
    } else if (!isEmpty(term)) {
      const searchPath = D.getSearchT3Path() + uriEncodedTerm + this.props.activeUrl;
      if (!this.props.isSearchOpen) {
        this.history.push(this.beforeSearch);
      }
      this.history.replace(searchPath);
    } else {
      this.props.router.replace(D.getSearchT3Path());
    }
  };

  onEscClicked: $TSFixMeFunction = () => {
    if (!this.props.isOnboardingPage) {
      this.props.router.replace(this.beforeSearch);
    } else {
      this.props.router.replace(D.getLandingPath());
    }
  };

  onKeyDown: $TSFixMeFunction = e => {
    const currentFocusTarget = document.activeElement;
    const searchListItemClassName = 'SearchResultsList__list__item';
    const firstSearchItem = this.searchListRef.current
      ? this.searchListRef.current.querySelector('.' + searchListItemClassName)
      : false;
    const focusedInHeader = this.headerRef.current
      ? this.headerRef.current.querySelector('input')?.contains(currentFocusTarget)
      : false;

    const focusedInSearchList = this.searchListRef.current
      ? this.searchListRef.current.contains(currentFocusTarget)
      : false;
    const focusedInFirstSearchItem =
      this.searchListRef.current && firstSearchItem
        ? firstSearchItem.contains(currentFocusTarget) || firstSearchItem === currentFocusTarget
        : false;

    if (!this.props.isSearchOpen) {
      return;
    }

    switch (e.keyCode) {
      // Up arrow
      case D.AppConstants.KeyCodes.UP_ARROW_KEY:
        e.preventDefault();

        if (currentFocusTarget) {
          // If focus is inside of this.searchListRef,
          // set focus on the next component, if there is one.
          if (focusedInSearchList && this.searchListRef.current) {
            setFocusWithinList(this.searchListRef.current, searchListItemClassName, 'previous');
            // If in first search result, focus back into input.
            if (focusedInFirstSearchItem && this.headerRef.current) {
              this.headerRef.current.querySelector('input')?.focus();
            }
          }
        }
        break;

      // Down arrow
      case D.AppConstants.KeyCodes.DOWN_ARROW_KEY:
        e.preventDefault();

        // If focus is inside of the search input,
        // then set focus onto the first list item.
        if (focusedInHeader && this.searchListRef.current) {
          setFocusWithinList(this.searchListRef.current, searchListItemClassName, 'first');
        }
        if (focusedInSearchList && this.searchListRef.current) {
          setFocusWithinList(this.searchListRef.current, searchListItemClassName, 'next');
        }
        break;

      // Back space
      case D.AppConstants.KeyCodes.BACK_SPACE_KEY:
        // Hitting backspace to clear the search field sends an action
        if (this.props.searchTerm.length === 1) {
          this.props.resetResults();
        }
        break;

      // Escape key
      case D.AppConstants.KeyCodes.ESCAPE_KEY:
        // Manages escape key exit from component, based on the region of user interaction.
        if (this.props.isSearchOpen && this.headerRef.current) {
          this.onEscClicked(e);
          const headerInput = this.headerRef.current.querySelector('input');
          if (headerInput) {
            headerInput.focus();
          }
        }
        break;

      // Enter key
      case D.AppConstants.KeyCodes.ENTER:
        // If focus is inside of the search input,
        // then set focus onto the first list item inside of this.searchListRef.
        if (focusedInHeader && this.searchListRef.current) {
          e.preventDefault();
          setFocusWithinList(this.searchListRef.current, searchListItemClassName, 'first');
        }
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        if (currentFocusTarget.classList.contains(searchListItemClassName)) {
          // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
          currentFocusTarget.querySelector('a.RowItemText').click();
        }
        break;
    }
  };

  closeSearch: $TSFixMeFunction = (event = null) => {
    this.props.closeSearch(this.props.searchType);

    const currentTarget = event && event.currentTarget;
    const hasCurrentTargetAndNotCTA =
      currentTarget &&
      currentTarget.classList &&
      !currentTarget.classList.contains('SearchT3__cta');
    if (hasCurrentTargetAndNotCTA) {
      if (this.props.hasSearched) {
        let route;
        if (D.isPathInNowPlayingPath(this.beforeSearch)) {
          route = this.props.nowPlayingPath;
        } else {
          route = this.beforeSearch;
        }
        this.props.router.push(route);
      } else {
        this.beforeSearch = this.props.pathname;
      }
    }
  };

  searchResultsRendered: $TSFixMeFunction = params => {
    this.props.searchResultsRendered(params);
  };

  onInputFocus: $TSFixMeFunction = hasSearchTerm => {
    if (!hasSearchTerm) {
      this.props.searchUIStateUpdate({
        hasFocus: true,
        isFocusEvent: true,
        searchType: this.props.searchType,
      });
    }
  };

  onInputBlur: $TSFixMeFunction = () => {
    this.props.searchUIStateUpdate({
      hasFocus: false,
      isFocusEvent: true,
      searchType: this.props.searchType,
    });
  };

  onInputChange: $TSFixMeFunction = inputValue => {
    if (!D.Utils.Route.isInSearchPath(location.pathname) && isEmpty(inputValue)) {
      return;
    }

    if (inputValue === this.props.searchTerm) {
      return;
    }

    this.updateRouteAfterUserInput(Utils.convertToValidSearchTerm(inputValue));
    this.props.openSearch({ searchTerm: inputValue });
    // NOTE: actual call to fullSearch happens in the SearchResultsList.jsx component
  };

  onInputClear: $TSFixMeFunction = event => {
    this.closeSearch(event);
  };

  onItemSelect: $TSFixMeFunction = (id, listIndex, resultAction) => {
    const params = {
      id,
      listIndex,
      resultAction,
      results: this.props.searchResults,
      searchFilter: this.props.activeUrl.substring(1),
      searchTerm: this.props.searchTerm,
    };
    this.props.searchItemSelect(params);
  };

  onResultsScroll: $TSFixMeFunction = () => {
    const params = {
      results: this.props.searchResults,
      searchFilter: this.props.activeUrl.substring(1),
      searchTerm: this.props.searchTerm,
    };
    this.props.searchResultsScroll(params);
  };

  onCTAClick: $TSFixMeFunction = event => {
    event.stopPropagation();
    this.closeSearch(event);
  };

  updateAppScrolling: $TSFixMeFunction = () => {
    if (this.props.searchType !== Constants.SearchKeys.ADD_VARIETY_SEARCH) {
      if (this.props.isSearchOpen) {
        this.props.disableBodyScrolling();
        return;
      }
      this.props.enableBodyScrolling();
    }
  };

  updateUrlState: $TSFixMeFunction = url => {
    if (this.props.activeUrl !== url) {
      D.Utils.Time.markTimeAtMomentForQuery(
        D.Constants.App.SearchTriggerMarks.SEARCH_STATS_FILTER_CHANGE,
        this.props.searchTerm,
      );
      this.updateRouteAfterUserInput(this.props.searchTerm, url);
      this.props.resetResults();
      this.props.filterChanged({
        results: this.props.searchResults,
        searchFilter: url.substring(1),
        searchTerm: this.props.searchTerm,
      });
    }
  };

  renderColdStartHeader: $TSFixMeFunction = () => {
    return (
      <div className='SearchT3__ColdStart__header'>
        <div className='SearchT3__ColdStart__header__icon'>
          <D.Icon className='premium__icon' glyph={AnotherLogoPremiumWhiteIcon} />
        </div>
        <div className='SearchT3__ColdStart__header__text'>
          <FormattedMessage {...Constants.coldStartWelcomeMessages.coldStartHeader} />
        </div>
      </div>
    );
  };

  getEmptyColdStartRow: $TSFixMeFunction = (titleMsg, titleTextMsg, icon) => {
    return (
      <div className='SearchT3__EmptyColdStart__row'>
        <div className='SearchT3__EmptyColdStart__row__icon'>
          <D.Icon className='icon-search' glyph={icon} />
        </div>
        <div className='SearchT3__EmptyColdStart__row__text'>
          <div className='SearchT3__EmptyColdStart__row__text__title'>
            <FormattedMessage {...titleMsg} />
          </div>
          <div className='SearchT3__EmptyColdStart__row__text__titleText'>
            <FormattedMessage {...titleTextMsg} />
          </div>
        </div>
      </div>
    );
  };

  renderColdStartBody: $TSFixMeFunction = () => {
    const message = Constants.coldStartWelcomeMessages;
    return (
      <div className='SearchT3__EmptyColdStart'>
        {this.getEmptyColdStartRow(
          message.searchAndPlayTitle,
          message.searchAndPlayTitleText,
          Search24Icon,
        )}
        {this.getEmptyColdStartRow(
          message.personalPlaylistTitle,
          message.personalPlaylistText,
          Playlist24Icon,
        )}
        {this.getEmptyColdStartRow(message.playTitle, message.playText, AnotherPlayIcon)}
      </div>
    );
  };

  renderCTANode: $TSFixMeFunction = () => {
    const message = Constants.messages.browse;
    const browsePath = D.getBrowsePath();
    return (
      <Link
        className='SearchT3__cta ButtonT3 ButtonT3--inlineBlock'
        onClick={this.onCTAClick}
        to={browsePath}
      >
        <FormattedMessage {...message} />
      </Link>
    );
  };

  render(): $TSFixMe {
    const classes = D.Utils.Css.createBEM('SearchT3', {
      active: this.props.isSearchOpen,
      centerPageSearch: this.props.isCenterPageSearch && !this.props.isSearchOpen,
      coldStartWelcome: this.props.showColdStart && !this.props.isOnboardingPage,
      nav:
        !this.props.isOnboardingPage && !this.props.showColdStart && !this.props.isCenterPageSearch,
      [this.props.navTheme]: !isEmpty(this.props.navTheme),
      onboardingStyle: this.props.isOnboardingPage,
      rightRail: this.props.isRightRailActive,
      shouldDropSearchToNextLine: this.props.shouldDropSearchToNextLine,
    });
    const baseUrl = D.getSearchT3Path() + this.props.searchTerm;
    const searchCoachmarkConfig = {
      coachmarkConfigs: [
        {
          id: D.MiniCoachmarkTypes.FIRST_TIME_PREMIUM_ACCESS,
          message: (
            <FormattedMessage {...D.MiniCoachmarkMessages.firstTimePremiumWelcomeSearchText} />
          ),
          targetOrigin: 'bottom',
        },
        {
          id: D.MiniCoachmarkTypes.FIRST_TIME_PREMIUM_WELCOME_SEARCH,
          message: (
            <FormattedMessage {...D.MiniCoachmarkMessages.firstTimePremiumWelcomeSearchText} />
          ),
          targetOrigin: 'bottom',
        },
        {
          id: D.MiniCoachmarkTypes.FIRST_TIME_NOW_PLAYING_SEARCH,
          message: <FormattedMessage {...D.MiniCoachmarkMessages.firstTimeWelcomeSearchText} />,
          targetOrigin: 'bottom',
        },
        {
          id: D.MiniCoachmarkTypes.FIRST_TIME_MY_STATIONS_SEARCH,
          message: <FormattedMessage {...D.MiniCoachmarkMessages.firstTimeWelcomeSearchText} />,
          targetOrigin: 'bottom',
        },
      ],
    };
    const coldStartSearchContainerHeight = this.state.containerHeight + 50;
    const { focusPlaceholder, placeholder, ...resultsListProps } = this.props;
    return (
      <div className={classes} ref='component' data-qa={D.QA.S}>
        <FocusTrap active={false}>
          <div className='SearchT3__header' ref={this.headerRef}>
            {this.props.showColdStart && this.renderColdStartHeader()}
            <D.MiniCoachmark {...searchCoachmarkConfig}>
              <GlobalSearchInput
                focusPlaceholder={focusPlaceholder}
                initialFocus={this.props.initialFocus}
                isCenterPageSearch={this.props.isCenterPageSearch}
                isOnboardingPage={this.props.isOnboardingPage}
                isRightRailActive={this.props.isRightRailActive}
                isSearchOpen={this.props.isSearchOpen}
                navTheme={this.props.navTheme}
                onInputBlur={this.onInputBlur}
                onInputChange={this.onInputChange}
                onInputClear={this.onInputClear}
                onInputFocus={this.onInputFocus}
                overrideFocus={this.props.hasFocus}
                overrideSearchTerm={this.props.searchTerm}
                placeholder={placeholder}
                shouldDropSearchToNextLine={this.props.shouldDropSearchToNextLine}
                showColdStart={this.props.showColdStart}
              />
            </D.MiniCoachmark>
            {this.hasSearchTerm() && (
              <D.FilterTypeNav
                parentComponentName='search'
                isColdStartWelcome={this.props.showColdStart}
                baseUrl={baseUrl}
                activeUrl={this.props.activeUrl}
                updateUrlState={this.updateUrlState}
                filterTypes={this.props.filterTypes}
              />
            )}
            {this.props.isSearchOpen && !this.hasSearchTerm() && !this.props.showColdStart && (
              <EmptySearch
                closeSearch={this.closeSearch}
                term={this.props.searchTerm}
                hasResults={this.props.hasResults}
                filter={this.props.activeUrl.substring(1)}
                isColdStartWelcome={this.props.showColdStart}
                ctaButton={this.renderCTANode()}
                isRightRailActive={this.props.isRightRailActive}
              />
            )}
            {!this.hasSearchTerm() && this.props.showColdStart && this.renderColdStartBody()}
          </div>
          {this.hasSearchTerm() && (
            <div ref={this.searchListRef}>
              <SearchResultsList
                {...resultsListProps}
                closeSearch={this.closeSearch}
                containerHeight={
                  this.props.showColdStart
                    ? coldStartSearchContainerHeight
                    : this.state.containerHeight
                }
                ctaButton={this.renderCTANode()}
                onItemSelect={this.onItemSelect}
                onScroll={this.onResultsScroll}
                searchResultsRendered={this.searchResultsRendered}
              />
            </div>
          )}
        </FocusTrap>
      </div>
    );
  }
}

let lastSearchTerm = '';
let lastActiveUrl = '';

export function mapStateToProps(state: $TSFixMe, ownProps: $TSFixMe): $TSFixMe {
  const path = location.pathname;

  let activeUrl = '/all';
  if (D.isFilteredSearch(path)) {
    const splitUrl = path.split('/');
    activeUrl = `/${splitUrl[splitUrl.length - 1]}`;
  }

  const user = D.getCurrentListenerFromState(state);
  const searchTerm = state.searchT3.getIn(
    [ownProps.searchType, Constants.SearchKeys.SEARCH_TERM],
    '',
  );
  if (lastSearchTerm !== searchTerm || lastActiveUrl !== activeUrl) {
    lastSearchTerm = searchTerm;
    lastActiveUrl = activeUrl;
  }
  const isSearchActive = state.searchT3.getIn([
    ownProps.searchType,
    Constants.SearchKeys.SEARCH_ACTIVE,
  ]);
  const isSearchHasFocus = state.searchT3.getIn([
    ownProps.searchType,
    Constants.SearchKeys.SEARCH_HAS_FOCUS,
  ]);
  const filterTypes = D.getMemoizedFilterTypes(true, true);
  const isSearchOpen = D.Utils.UIState.getIsSearchOpen(state);
  return {
    activeUrl,
    actualPathname: location.pathname,
    branding: (user && user.get('branding')) || '',
    filterTypes,
    focusPlaceholder: Utils.determineFocusedSearchPlaceholder(state, ownProps.showColdStart),
    hasFetchedData: state.searchT3.get(Constants.SearchKeys.FETCHED_SEARCH_RESULTS),
    hasFocus: ownProps.showColdStart || isSearchHasFocus,
    hasResults: state.searchT3.get(Constants.SearchKeys.SEARCH_RESULTS).size !== 0,
    hasSearched: isSearchOpen,
    isAnonymous: D.isAnonymousListener(state),
    isListenerPremium: D.hasPremiumFeatures(state),
    isNavLogoDark:
      !ownProps.isRightRailActive &&
      !D.getIsNowPlayingOpen(state) &&
      D.getInDomain('displayAds.utils.getIsDisplayAdAllowedOnPage', false)(state) &&
      !ownProps.isAnonymous,
    isScrolled: state.scroll.get(D.ScrollKeys.IS_SCROLLED),
    isSearchActive,
    isSearchOpen,
    listenerImgUrl: user ? D.getListenerImageUrl(user) : '',
    nowPlayingPath: D.getNowPlayingPath(state),
    pathname: D.getCurrentPathnameFromState(state),
    placeholder: Utils.determineSearchPlaceholder(
      state,
      ownProps.showColdStart,
      ownProps.isCenterPageSearch,
    ),
    searchResults: state.searchT3.get(Constants.SearchKeys.SEARCH_RESULTS),
    searchTerm,
  };
}

// eslint-disable-next-line react-redux/mapDispatchToProps-returns-object
const mapDispatchToProps: $TSFixMe = (dispatch: $TSFixMe) => {
  return bindActionCreators(
    {
      clickedSearchBoxComponent: D.clickedSearchBoxComponent,
      closeModal: D.closeModal,
      closeSearch: D.Actions.UseCases.closeSearch,
      disableBodyScrolling: D.disableBodyScrolling,
      enableBodyScrolling: D.enableBodyScrolling,
      filterChanged: Actions.filterChanged,
      openDropdown: D.openDropdown,
      openSearch: D.Actions.UseCases.openSearch,
      resetResults: Actions.resetResults,
      searchItemSelect: Actions.searchItemSelect,
      searchResultsRendered: Actions.searchResultsRendered,
      searchResultsScroll: Actions.searchResultsScroll,
      searchUIStateUpdate: Actions.searchUIStateUpdate,
    },
    dispatch,
  );
};

/** default export for the connected component (for app) */
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));
